import React, { useEffect } from 'react';
import { useCopyToClipboard } from 'Shared/utils/hooks/use-copy-to-clipboard';

// Helpers
import { isConsumerDomain, validEmail } from 'Shared/helpers';

// Hooks
import { useToggle } from 'Shared/utils/hooks';
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import MobileOnboardingWrapper from '../../MobileOnboardingWrapper/MobileOnboardingWrapper';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpModal, WpModalBody, WpModalHeader } from 'Wpds/components/modal';
import WpToastManager from 'Wpds/components/toast/WpToastManager';

// Styles
import './MarketingThirdPartyBrowswerSignup.scss';

const MarketingThirdPartyBrowswerSignup = () => {
  const [modalOpen, toggleModalOpen] = useToggle(false);
  const { handleSubmitThirdPartyBrowserEmail, flowType, onboardingState } = useOnboardingState();
  const signupLink = `${window.location.origin}/onboarding/wizard?onboarding_state_token=${onboardingState.uuid}`;
  const { onCopyTextToClipboard } = useCopyToClipboard({ textToCopy: signupLink });

  const isValidEmail = email => {
    return validEmail(email) && !isConsumerDomain(email);
  };

  const handleSendLinkClick = ({ email }) => {
    handleSubmitThirdPartyBrowserEmail({ email }).then(() => {
      toggleModalOpen();
      WpToastManager.success('Email sent!');
    });
  };

  const handleCopyLinkClick = () => {
    (window as any).analytics.track('Copied Signup Link to Clipboard', {});
    onCopyTextToClipboard();
  };

  const baseClassName = 'MarketingThirdPartyBrowswerSignup';

  useEffect(() => {
    (window as any).analytics.identify({ flowType });
    (window as any).analytics.track('Viewed In-App Browser Screen', {}, { integrations: { Calixa: false } });
  }, []);

  return (
    <>
      <MobileOnboardingWrapper className={baseClassName}>
        <div className={`${baseClassName}__text`}>
          <img
            className={`${baseClassName}__text__img`}
            src="https://piprodperformassets.blob.core.windows.net/assets/charma_hi.png"
            alt="Hi"
          />
          <h1 className={`${baseClassName}__text__title`}>Sign up for PI Perform</h1>
          <h5 className={`${baseClassName}__text__desc`}>Open the link in a Safari or Chrome browser to sign up.</h5>
        </div>
        <div className={`${baseClassName}__signupLink`}>
          <WpTextField
            name="signupLink"
            id="signupLink"
            type="text"
            label="Signup link"
            showRequiredIndicator={false}
            value={signupLink}
            disabled
            labelHidden
          />
        </div>
        <WpButtonGroup stacked>
          <WpButton size="lg" block color="primary" onClick={handleCopyLinkClick}>
            <WpIcon prefix="fal" name="link" />
            Copy link
          </WpButton>
          <WpButton size="lg" block btnType="submit" variant="secondary" onClick={toggleModalOpen}>
            Email me the link
          </WpButton>
        </WpButtonGroup>
        <WpModal
          isOpen={modalOpen}
          onToggle={toggleModalOpen}
          size="sm"
          innerClassName={baseClassName}
          dismissOnBackdrop={false}
        >
          <WpModalHeader>Please enter your email address</WpModalHeader>
          <WpModalBody>
            <WpForm onSubmit={handleSendLinkClick}>
              <WpFormLayout direction="vertical">
                <WpTextField
                  name="email"
                  id="email"
                  type="text"
                  label="Work email"
                  placeholder="Work email"
                  required
                  validate={{
                    isEmail: {
                      callback: isValidEmail,
                      error: 'Please enter a valid work email.',
                    },
                  }}
                  showRequiredIndicator={false}
                  disabled={false}
                  autoFocus
                  autoComplete={false}
                  labelHidden
                />
              </WpFormLayout>
              <WpButton block btnType="submit">
                Send me the link
              </WpButton>
            </WpForm>
          </WpModalBody>
        </WpModal>
      </MobileOnboardingWrapper>
    </>
  );
};

export default MarketingThirdPartyBrowswerSignup;
